import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import ExperienceAccordion from "../../containers/experienceAccordion/ExperienceAccordion";
import { experience } from "../../portfolio";
import { Link } from "react-router-dom";
import "./Experience.css";

function Experience({ theme, onToggle, isDark }) {
  const nightMode = isDark !== false;

  return (
    <div
      className={`experience-main career-observatory ${
        nightMode ? "career-night" : "career-paper"
      }`}
    >
      <Header theme={theme} onToggle={onToggle} isDark={isDark} />

      <main className="career-page-shell">
        <div className="career-grid-field" aria-hidden="true" />
        <div className="career-glow career-glow-violet" aria-hidden="true" />
        <div className="career-glow career-glow-cyan" aria-hidden="true" />

        <section className="career-hero" aria-labelledby="career-page-title">
          <div className="career-hero-copy">
            <p className="career-kicker">
              <span className="career-live-dot" /> FIELD LOG / PROFESSIONAL
              EXPERIENCE
            </p>
            <h1 id="career-page-title">
              Work that moves
              <br />
              <em>from signal to system.</em>
            </h1>
            <p className="career-subtitle">{experience.subtitle}</p>
            <p className="career-description">{experience.description}</p>
            <div className="career-hero-actions">
              <Link to="/projects" className="career-primary-link">
                View selected work <span>↗</span>
              </Link>
              <Link to="/opensource" className="career-secondary-link">
                GitHub activity <span>↗</span>
              </Link>
              <a href="#career-archive" className="career-scroll-link">
                Explore the field log <span>↓</span>
              </a>
              <span className="career-route-mark">
                US ↔ INDIA / REMOTE-READY
              </span>
            </div>
          </div>

          <div
            className="career-signal-stage"
            aria-label="Career systems visualization"
          >
            <div className="career-stage-grid" aria-hidden="true" />
            <div
              className="career-radar-ring career-radar-ring-one"
              aria-hidden="true"
            />
            <div
              className="career-radar-ring career-radar-ring-two"
              aria-hidden="true"
            />
            <div className="career-radar-sweep" aria-hidden="true" />
            <svg
              className="career-signal-map"
              viewBox="0 0 600 490"
              aria-hidden="true"
            >
              <defs>
                <linearGradient id="careerSignalGradient" x1="0" x2="1">
                  <stop offset="0" stopColor="currentColor" stopOpacity="0" />
                  <stop
                    offset="0.42"
                    stopColor="currentColor"
                    stopOpacity="0.9"
                  />
                  <stop
                    offset="1"
                    stopColor="currentColor"
                    stopOpacity="0.22"
                  />
                </linearGradient>
              </defs>
              <path
                d="M64 356 C135 308 164 398 237 299 S347 157 411 228 S491 271 550 91"
                fill="none"
                stroke="url(#careerSignalGradient)"
                strokeWidth="2"
              />
              <path
                d="M64 356 C135 308 164 398 237 299 S347 157 411 228 S491 271 550 91"
                className="career-signal-glow"
                fill="none"
                stroke="currentColor"
                strokeWidth="8"
              />
              <circle cx="64" cy="356" r="7" />
              <circle cx="237" cy="299" r="7" />
              <circle cx="411" cy="228" r="8" />
              <circle cx="550" cy="91" r="7" />
            </svg>
            <div className="career-stage-node career-stage-node-start">
              <span>01</span>
              <b>IMAGE → 3D</b>
              <small>automation</small>
            </div>
            <div className="career-stage-node career-stage-node-current">
              <span>02</span>
              <b>AI SYSTEMS</b>
              <small>production</small>
            </div>
            <div className="career-stage-telemetry">
              <span>DEPLOYMENT VECTOR</span>
              <b>8 MONTHS</b>
              <i />
              <small>BUILD · SHIP · ITERATE</small>
            </div>
            <div className="career-stage-corner corner-a" aria-hidden="true" />
            <div className="career-stage-corner corner-b" aria-hidden="true" />
            <div className="career-stage-corner corner-c" aria-hidden="true" />
            <div className="career-stage-corner corner-d" aria-hidden="true" />
          </div>
        </section>

        <section className="career-evidence-band" aria-label="Career summary">
          <div>
            <span>PRODUCTION AI</span>
            <b>
              8 <small>MONTHS</small>
            </b>
          </div>
          <div>
            <span>ROLES LOGGED</span>
            <b>
              02 <small>INTERNSHIPS</small>
            </b>
          </div>
          <div>
            <span>OPERATING RANGE</span>
            <b>
              AI <small>× HARDWARE</small>
            </b>
          </div>
          <p>
            <span /> Build the architecture, test the seams, then make the story
            land with the people who need it.
          </p>
        </section>

        <section
          className="career-archive-section"
          id="career-archive"
          aria-labelledby="career-archive-title"
        >
          <div className="career-section-heading">
            <div>
              <p className="career-kicker">
                <span /> THE RECORD
              </p>
              <h2 id="career-archive-title">
                A timeline of
                <br />
                <em>things made real.</em>
              </h2>
            </div>
            <p>
              Open each chapter to trace the work from the first prototype
              through production systems and client-facing outcomes.
            </p>
          </div>
          <ExperienceAccordion sections={experience.sections} />
        </section>
      </main>

      <Footer theme={theme} onToggle={onToggle} isDark={isDark} />
      <TopButton theme={theme} />
    </div>
  );
}

export default Experience;
